function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import * as React from 'react';
/**
 * @param {React.ComponentType} WrappedComponent - React component
 */

export function withInnerRef(WrappedComponent) {
  // eslint-disable-next-line react/display-name
  return React.forwardRef((props, ref) => React.createElement(WrappedComponent, _extends({}, props, {
    innerRef: ref
  })));
}